import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {loginUiTexts} from 'data/ui-texts';
import {gamesData} from 'data/games-data';
import {getText} from 'helpers/language-helper';
import Logo from 'components/logo/logo';
import LoginFacilitatorController from './login-facilitator/login-facilitator-controller';
import LoginGroupController from './login-group/login-group-controller';
import './login-default.scss';

const LoginDefault = ({languageId, gameType}) => {
	/* Active login box */
	const [activeLoginBox, setActiveLoginBox] = useState('facilitator');

	/* Game title */
	const gameTitle = (gamesData.hasOwnProperty(gameType) 
		? getText(gamesData[gameType].titleOverview, languageId) 
		: ''
	);

	return (
		<div className={'LoginDefault ' + activeLoginBox}>
			<Logo classes={['login']} />
			<div className="LoginDefault-gameTitle">{gameTitle}</div>
			<div className="LoginDefault-tabContainer">
				<div
					className={'LoginDefault-tabButton' + (activeLoginBox === 'facilitator' ? ' active' : '')}
					onClick={() =>{setActiveLoginBox('facilitator');}}
				>{getText(loginUiTexts.facilitator, languageId)}</div>
				<div
					className={'LoginDefault-tabButton' + (activeLoginBox === 'group' ? ' active' : '')}
					onClick={() =>{setActiveLoginBox('group');}}
				>{getText(loginUiTexts.group, languageId)}</div>
			</div>
			<div className="LoginDefault-formContainer">
				{activeLoginBox === 'facilitator' && 
						<LoginFacilitatorController languageId={languageId} />}
				{activeLoginBox === 'group' && 
						<LoginGroupController languageId={languageId} gameType={gameType} />}
			</div>
			<div className='LoginDefault-logo' onClick={() => {window.open('https://cphgamelab.dk/', '_blank', 'noopener,noreferrer');}} ></div>
		</div>
	);
};

LoginDefault.propTypes = {
	languageId: PropTypes.string.isRequired,
	gameType: PropTypes.string.isRequired,
};

export default LoginDefault;